import axios from 'axios';

import { AuthInterceptor, AuthService } from '@sine/auth-client';

import { sessionStorage, storage } from '../storage/storage.service';
import deviceService from './device.service';

const authService = new AuthService({
  authApiUrl: window.env.REACT_APP_SINE_ID_API_ENDPOINT,
  coreAuthApiUrl: window.env.REACT_APP_SINE_CORE_API_ENDPOINT,
  rootClientUrl: `${window.location.origin}${window.env.PUBLIC_URL}`,
  // Only used for device-based authentication, which Admin Client doesn't support
  rootClientAuthApiUrl: window.env.REACT_APP_SINE_ID_API_ENDPOINT,
  storage,
  sessionStorage,
  axiosInstance: axios,
});

const authInterceptor = new AuthInterceptor(axios, authService);
authInterceptor.startIntercepting();

/**
 * Wait until the device service has grabbed itself a token and then attempt
 * to initialise the auth service!
 */
let registeredDeviceToken: string | undefined;
function handleDeviceTokenChanged(newDeviceToken: string | undefined) {
  if (registeredDeviceToken && registeredDeviceToken !== newDeviceToken) {
    // Authentication previously performed with different device token, nothing we can do here.
    registeredDeviceToken = undefined;
    void authService.trashUser();
  } else if (newDeviceToken) {
    // Device token is ready, let's try and initialise
    registeredDeviceToken = newDeviceToken;
    void authService.initialize();
  }
}

handleDeviceTokenChanged(deviceService.getDeviceToken());
deviceService.addDeviceTokenListener(handleDeviceTokenChanged);

export default authService;
